// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_56-0";